import { useState } from 'react';
import CountLink from './CountLink';
import LeadDetailsDialog from './LeadDetailsDialog';
import { KIND_LABEL, prefetchLeadDetails } from './leadDetails';

// Makes a count column clickable and owns the popup, for LCR / ACR / LTA:
//   const drill = useLeadDrilldown('lcr', month);
//   { field: 'leadsCount', headerName: 'Leads Assigned', align: 'right', render: drill.cell('assigned', 'leadsCount') }
//   ...
//   {drill.dialog}
const useLeadDrilldown = (metric, month) => {
  const [open, setOpen] = useState(null);
  const requestFor = (kind, row) => ({ metric, kind, userId: row.entityId, userName: row.entityName, category: row.leadCategory, month });

  const cell = (kind, field) => (row) => (
    <CountLink
      count={row[field]}
      label={`${KIND_LABEL[kind].toLowerCase()} for ${row.entityName}`}
      onOpen={() => setOpen(requestFor(kind, row))}
      onPrefetch={() => prefetchLeadDetails(requestFor(kind, row))}
    />
  );

  const dialog = open ? <LeadDetailsDialog request={open} onClose={() => setOpen(null)} /> : null;
  return { cell, dialog };
};

export default useLeadDrilldown;
